module.exports = __webpack_public_path__ + "media/images/home/okra_active-6517a796c4ff8d3d64c01deca571d413.png";